<template>
  <span>
    <b-modal :id="modalId" :title="`Inspeccion #${id}`" @show="onShow" @hide="onHide" size="lg">
      <b-spinner v-if="!ready"></b-spinner>
      <div v-if="ready">
        <div>
          <p style="text-align: right">Cliente: Chilean Marroni Farms</p>
          <h1>
            Informe de control de Calidad <br />
            Recepción Materia Prima - Castañas
          </h1>
          <h2>Datos de recepcion de productor</h2>
          <table style="border-collapse: collapse; width: 100%; border: solid black 2px" cellspacing="0">
            <tbody>
              <tr>
                <th style="border: solid 1px black; text-align: left">Fecha de Recepción</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.fechaRecepcion }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Nombre de Productor</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.productor }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Variedad</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.variedad }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Número de Guía de Despacho</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.guia }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Observaciones Materia Prima</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.observacionRecepcion }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Estado de Transporte (Conforme: Sí - No)</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.conforme }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Observaciones de Transporte</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.observacionTransporte }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">Temperatura de Pulpa ºC</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.tTransporte }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <h2>Detalle de calidad</h2>
          <table style="border-collapse: collapse; width: 100%; border: solid black 2px" cellspacing="0">
            <tbody>
              <tr style="background-color: dimgray; color: #fff">
                <th style="border: solid 1px black; text-align: left"></th>
                <th style="border: solid 1px black; text-align: left">% de Defectos</th>
                <th style="border: solid 1px black; text-align: left">Nota de Calidad</th>
                <th style="border: solid 1px black; text-align: left">Valoración Nota Calidad</th>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Pudrición</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.porcentajePudricion }}</td>
                <td
                  style="border: solid 1px black; text-align: center; font-size: 30px; font-weight: 800"
                  rowspan="10"
                  :class="
                    inspection.notaDefectosCriticos == 2
                      ? 'bg-success'
                      : inspection.notaDefectosCriticos == 3
                      ? 'bg-warning'
                      : 'bg-danger'
                  "
                >
                  {{ inspection.notaFinal }}
                </td>
                <td
                  style="border: solid 1px black; text-align: center; font-weight: 800"
                  rowspan="10"
                  :class="
                    inspection.notaDefectosCriticos == 2
                      ? 'bg-success'
                      : inspection.notaDefectosCriticos == 3
                      ? 'bg-warning'
                      : 'bg-danger'
                  "
                >
                  {{ inspection.valoracionNotaCalidad }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Deshidratados</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.porcentajeDeshidratacion }}</td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">
                  Nota Defectos Críticos
                </th>
                <th style="border: solid 1px black; text-align: center; background-color: lightgray">
                  {{ inspection.notaDefectosCriticos }}
                </th>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Material Extraño</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.porcerntajeMaterialExtrano }}</td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Herida / Pardidura</th>
                <td style="border: solid 1px black; text-align: center">
                  {{ inspection.porcentajeHeridasPartiduras }}
                </td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Echandés</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.porcentajeEchandes }}</td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Tabicado</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.porcentajeTabicado }}</td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Mancha Verde</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.porcentajeManchasVerdes }}</td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left">% Mancha Blancas</th>
                <td style="border: solid 1px black; text-align: center">{{ inspection.porcentajeManchasBlancas }}</td>
              </tr>
              <tr>
                <th style="border: solid 1px black; text-align: left; background-color: lightgray">
                  Nota Defectos No Críticos
                </th>
                <th style="border: solid 1px black; text-align: center; background-color: lightgray">
                  {{ inspection.notaNoCriticos }}
                </th>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 v-if="images.lenght > 0">Imágenes de Defectos</h2>
        <div style="min-height: 150px; border: solid black 1px; margin-bottom: 20px">
          <div class="gallery">
            <div class="gallery-panel" v-for="photo in images" :key="photo.id">
              <img
                :src="`https://www.appsheet.com/template/gettablefileurl?appName=CalidadCMF-1001727519&tableName=Calidad&fileName=${encodeURIComponent(
                  photo.foto
                )}`"
              />
            </div>
          </div>
          <p>{{ inspection.observations }}</p>
        </div>
        <h2>Detalle de datos de la inspección</h2>
        <div>
          <b-table stacked :items="[item]"></b-table>
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "ModalDetalleInspeccion",
  computed: {
    modalId() {
      return "modal-detalle-inspeccion-" + this.id;
    }
  },
  data() {
    return {
      ready: false,
      inspection: {},
      images: []
    };
  },
  methods: {
    onShow() {
      this.getImages(this.item.idSh).then(() => {
        this.ready = true;
      });
      this.inspection = this.item;
    },
    onHide() {
      this.ready = false;
      this.inspection = {};
    },
    async getImages(id_inspection) {
      try {
        const response = await this.$axios.get(
          `https://api.sheety.co/17a15e538248668e7a07764e201fdfa9/calidadCmf/fotos?filter[idCalidad]=${id_inspection}`
        );
        this.images = response.data.fotos;
      } catch (error) {
        console.log(error);
      }
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  grid-gap: 1rem;
  max-width: 80rem;
  margin: 5rem auto;
  padding: 0 5rem;
}

.gallery-panel img {
  width: 100%;
  height: 22vw;
  object-fit: cover;
  border-radius: 0.75rem;
}

.text-danger {
  color: red;
}
.no-space {
}
.danger {
  background-color: red;
}
.warning {
  background-color: yellow;
}
.success {
  background-color: green;
}

#content {
  position: relative;
}
#content img {
  position: absolute;
  top: 0px;
  right: 0px;
}
#logo {
  position: fixed;
  top: 0px;
  left: 6px;
  height: 60px;
}
h1 {
  margin-top: 50px;
  font-size: 20px;
  text-align: center;
  text-decoration: underline;
  text-transform: uppercase;
}
h2 {
  font-size: 16px;
  margin-top: 25px;
  text-align: center;
  text-transform: uppercase;
}
table {
  table-layout: fixed;
}
</style>
